/**
 * 基础菜单 科目管理
 */
<template>
  <div style="height: 100%">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>科目管理</el-breadcrumb-item>
    </el-breadcrumb>


    <div class="tree-con">
      <div class="head-search">
        <el-input
          v-model="treeName"
          maxLength="15"
          placeholder="请输入"
          clearable
          size="small"
        >
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>

      <!-- 科目树 -->
      <div class="head-tree">
        <el-tree
          :data="treeOptions"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :expand-on-click-node="false"
          ref="tree"
          node-key="value"
          highlight-current
          :default-expanded-keys="treeArr"
          @node-click="handleNodeClick"
          @node-contextmenu="rightUpdata"
        >
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <i
              class="custom-tree-node-icon"
              :class="node.isLeaf ? 'el-icon-aim' : 'el-icon-folder-opened'"
            ></i>
            <span
              class="s_l custom-tree-node-name "
              :title="data.label"
              :style="{ 'font-weight': node.isLeaf ? '400' : 'bold' }"
            >{{ data.label }}</span
            >
          </div>
        </el-tree>
      </div>

    </div>

    <!-- 右侧部分 -->
    <div class="con-rig">
      <div style="height: 40%;">
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="queryParams" class="user-search" style="float: right;">
          <!--        <el-form-item label="搜索：">
                    <el-input size="small" v-model="queryParams.typeName" placeholder="输入科目名称"></el-input>
                  </el-form-item>-->
          <el-form-item>
            <!--          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>-->
            <el-button size="small" type="primary" icon="el-icon-plus" v-show="addShow && listData.length == 0" @click="handleFormEdit()">添加</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column label="序号" align="center" type="index" width="60"/>
          <el-table-column prop="tag" label="标签id"/>
          <el-table-column prop="tagName" label="标签名称"/>

          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleFormEdit(scope.$index, scope.row)">编辑</el-button>
              <!--            <el-button size="mini" type="danger" @click="deleteKmPz(scope.$index, scope.row)">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="height: 45%;">
        <h2 style="padding-left: 10px;">体验试卷</h2>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="queryParams" class="user-search" style="float: right;" v-show="testShow && testList.length == 0">
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="handleTestFormEdit()">添加</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="testList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column label="序号" align="center" type="index" width="60"/>
          <el-table-column prop="paperName" label="试卷名称"/>
          <el-table-column prop="paperUrl" label="试卷地址"/>

          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleTestFormEdit(scope.$index, scope.row)">编辑</el-button>
              <!--            <el-button size="mini" type="danger" @click="deleteKmPz(scope.$index, scope.row)">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>


    <!--  科目新增 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" :close-on-click-modal="false" @click="closeDialog">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form">
        <el-form-item label="父级科目" prop="parentName">
          <el-input @focus="openType" v-model="form.parentName" placeholder="请选择父级科目"/>
        </el-form-item>
        <el-form-item label="培训科目" prop="typeName">
          <el-input size="small" maxLength="100" v-model="form.typeName" placeholder="请输入科目名称"></el-input>
        </el-form-item>
        <el-form-item label="标签" prop="tag">
          <el-select size="small" style="width: 100%" clearable v-model="form.tag" placeholder="请选择标签">
            <el-option
              v-for="x in tagList"
              :label="x.tagName"
              :value="x.id"
              :key="x.id"
              @click.native="changeTag(x,1)">
            </el-option>
          </el-select>
        </el-form-item>
        <!--  @input="formatInportData($event,'11','passHour',form)" -->
<!--        <el-form-item label="标签id" prop="tag">
          <el-input size="small" v-model="form.tag" placeholder="请输入标签id"></el-input>
        </el-form-item>
        <el-form-item label="标签名称" prop="tagName">
          <el-input size="small" v-model="form.tagName" placeholder="请输入标签名称"></el-input>
        </el-form-item>-->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 选择 父级项目 -->
    <el-dialog :close-on-click-modal="false" title="选择父级项目" width="20vw" top="6vh" :visible.sync="openUpType" append-to-body>
      <div class="tree-con " style="margin: 0 auto">

        <div class="head-search">
          <el-input
            v-model="treeName2"
            maxLength="15"
            placeholder="请输入"
            clearable
            size="small"
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>

        <div class="head-tree">
          <el-tree
            :data="treeOptions"
            :props="defaultProps"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            ref="tree"
            node-key="value"
            :default-expanded-keys="treeArr"
            @node-click="handleNodeClick2"
          >
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <i
                class="custom-tree-node-icon"
                :class="node.isLeaf ? 'el-icon-aim' : 'el-icon-folder-opened'"
              ></i>
              <span
                class="s_l custom-tree-node-name "
                :title="data.label"
                :style="{ 'font-weight': node.isLeaf ? '400' : 'bold' }"
              >{{ data.label }}</span
              >
            </div>
          </el-tree>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpType">确 定</el-button>
        <el-button @click="cancelUpType">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 鼠标右击 树菜单栏 -->
    <div v-show="menuVisible">
      <div id="menu" class="menu">
        <div class="menu-item" @click="handleEdit(1)">新增</div>
        <div class="menu-item" @click="handleEdit(2)">编辑</div>
        <div class="menu-item" @click="deleteUser">删除</div>
      </div>
    </div>

    <!--  科目配置 新增 -->
    <el-dialog :title="detailTitle" :visible.sync="detailShow" width="30%" :close-on-click-modal="false" @click="detailClose">
      <el-form label-width="120px" :model="detailForm" :rules="detailRules" ref="detailForm">
        <el-form-item label="标签" prop="tag">
          <el-select size="small" style="width: 100%" clearable v-model="detailForm.tag" placeholder="请选择标签">
            <el-option
              v-for="x in tagList"
              :label="x.tagName"
              :value="x.id"
              :key="x.id"
              @click.native="changeTag(x,2)">
            </el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="标签id" prop="tag">
          <el-input size="small" v-model="detailForm.tag" placeholder="请输入标签id"></el-input>
        </el-form-item>
        <el-form-item label="标签名称" prop="tagName">
          <el-input size="small" v-model="detailForm.tagName" placeholder="请输入标签名称"></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailClose">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitDetailForm()">保存</el-button>
      </div>
    </el-dialog>

    <!--  体验试卷 新增 -->
    <el-dialog :title="testTitle" :visible.sync="testDetailShow" width="30%" :close-on-click-modal="false" @click="detailClose">
      <el-form label-width="120px" :model="detailForm" :rules="detailRules" ref="testDetailForm">
        <el-form-item label="试卷名称" prop="paperName">
          <el-input size="small" v-model="detailForm.paperName" placeholder="请输入试卷名称"></el-input>
        </el-form-item>
        <el-form-item label="试卷地址" prop="paperUrl">
          <el-input size="small" v-model="detailForm.paperUrl" placeholder="请输入试卷地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailClose">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitTestDetailForm()">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  // 科目
  querySubjectList,
  selectAreaTree,
  saveSubject,
  updateSubject,
  deleteSubjectById,
  querySubjectDetail,


  // 科目配置
  findSubjectDescribeList,
  savaSubjectDescribe,
  updateSubjectDescribe,
  deleteSubjectDescribe,
  querySubjectDescribeDetail,
  querySubjectDescribeBySubjectId, queryTagBySubjectId, queryTagList, queryTestPapeBySubjectId       // 根据科目id 查询科目配置信息

} from '../../api/subjectTree'
import { formatInportData } from '../../utils/util'
import Pagination from '../../components/Pagination'
import Template from "../../components/template";
export default {
  data() {
    return {
      addShow: false,
      id: '',
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '新增',
      form: {},
      // rules表单验证
      rules: {
        typeName: [
          { required: true, message: '请输入科目名称', trigger: 'blur' }
        ],
        tag: [
          { required: true, message: '请选择标签', trigger: 'blur' }
        ],
      },
      queryParams: {
        page: 1,
        size: 10
      },
      testShow: false,
      testList: [], //试卷数据
      testTitle: '',
      testDetailShow: false,

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      openUpType: false,
      // 左侧树
      treeArr: [],  // 默认展示第二级树节点
      treeName: undefined,
      treeName2: undefined,
      treeOptions: undefined,
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 树状图 双击事件参数
      treeClickCnt: 0,
      treeClickTimeout: null,

      // 右键点击 菜单
      menuVisible: false,


      // 科目配置 信息
      detailSubjectId: '',
      detailShow: false,
      detailTitle: '添加',
      detailForm: {},
      detailRules: {
        tag: [
          { required: true, message: '请选择标签', trigger: 'blur' }
        ],
        paperName: [
          { required: true, message: '请选择试卷名称', trigger: 'blur' }
        ],
        paperUrl: [
          { required: true, message: '请选择试卷地址', trigger: 'blur' }
        ],
      },

      tagList: []
    }
  },
  watch: {
    // 根据名称筛选部门树
    treeName(val) {
      this.$refs.tree.filter(val);
    },
    treeName2(val) {
      this.$refs.tree.filter(val);
    }
  },
  // 注册组件
  components: {
    Template,
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.initData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatInportData,
    initData() {
      this.selectAreaTree();
      // this.findTagList();
      // this.getdata()
    },

    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({type: 1}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
          res.data.forEach(x => {
            this.treeArr.push(x.value)
          })
        }
      })
    },
    // 查询标签列表
    findTagList() {
      queryTagList().then(res => {
        if (res.code == 200) {
          this.tagList = res.data;
        }
      })
    },
    // 筛选树节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 节点单击事件
    handleNodeClick(data) {
      console.log('data', data);
      this.$refs.tree.setCurrentKey(data.value);
      this.detailSubjectId = data.value;
      this.queryTagBySubjectId(data.value);
      this.queryTestPapeBySubjectId(data.value);
    },
    queryTagBySubjectId(id) {
      queryTagBySubjectId({subjectId: id}).then(res => {
        if (res.code == 200) {
          this.addShow = true;
          if (res.data != '' && res.data != null && res.data != undefined) {
            this.listData = [res.data];
          } else {
            this.listData = [];
          }
        }
      })
    },
    queryTestPapeBySubjectId(id) {
      queryTestPapeBySubjectId({subjectId: id}).then(res => {
        if (res.code == 200) {
          this.testShow = true;
          if (res.data != '' && res.data != null && res.data != undefined) {
            this.testList = [res.data];
          } else {
            this.testList = [];
          }
        }
      })
    },
    changeTag(item, x) {
      if (x == 1) {
        this.$set(this.form, 'tag', item.id);
        this.$set(this.form, 'tagName', item.tagName);
      } else if (x == 2) {
        this.$set(this.detailForm, 'tag', item.id);
        this.$set(this.detailForm, 'tagName', item.tagName);
      }
    },

    // 鼠标右击事件
    rightUpdata(MouseEvent, Object, Node, element) {
      this.id = Object.value;
      this.form.parentId = Object.value;
      this.form.parentName = Object.label;
      this.menuVisible = false;
      this.menuVisible = true;
      var menu = document.querySelector('#menu');
      menu.style.left = MouseEvent.clientX + 20 + 'px';
      menu.style.top = MouseEvent.clientY + 5 + 'px';
      document.addEventListener('click', this.foo);
      this.clickNode = Node;
    },
    foo() {
      this.menuVisible = false;
      document.removeEventListener('click', this.foo);
    },
    /*editTree({data}) {
      this.treeVisible = true;
      this.treeForm = JSON.parse(JSON.stringify(data));
    },*/

    // 打开父级项目选择框
    openType() {
      this.openUpType = true
    },
    // 选择父级项目 节点点击事件
    handleNodeClick2(data) {
      // 如果点击的id不相同，则重置点击次数
      if (data.value != this.form.parentId) {
        this.treeClickCnt = 0;
      }
      this.form.parentId = data.value
      this.form.parentName = data.label
      this.treeClickCnt++;

      // 注册清空点击次数计时器任务
      window.clearTimeout(this.treeClickTimeout);
      this.treeClickTimeout = window.setTimeout(() => {
        this.treeClickCnt = 0;
      }, 300);

      // 连续点击多次则不做任何事情
      if (this.treeClickCnt > 2) return;
      // 点击一次时单击事件
      if (this.treeClickCnt == 1) {
        // 单击事件
        console.log('单击');
      }
      // 点击两次时双击事件
      if (this.treeClickCnt == 2) {
        // 双击事件
        console.log('双击');
        this.submitUpType()
      }

    },
    // 保存父级项目
    submitUpType() {
      this.openUpType = false;
    },
    cancelUpType() {
      this.form.parentId = undefined
      this.form.parentName = undefined
      this.openUpType = false;
    },

    // 获取科目配置
    getdata(parameter) {
      this.loading = true
      findSubjectDescribeList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },
    //显示编辑界面
    handleEdit(x) {
      this.editFormShow = true
      if (x == 2) {
        this.title = '修改'
        querySubjectDetail(this.id).then(res => {
          if (res.code == 200) {
            this.form = res.data;
          }
        })
      } else {
        this.title = '添加'
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.form.id != undefined) {
            // 修改
            updateSubject(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                // this.getdata()
                this.selectAreaTree()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '科目修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.editFormShow = false
                this.loading = false
                this.$message.error('科目修改失败，请稍后再试！')
              })
          } else {
            // 新增
            saveSubject(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                // this.getdata()
                this.selectAreaTree()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '科目保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.editFormShow = false
                this.loading = false
                this.$message.error('科目保存失败，请稍后再试！')
              })
          }
        } else {
          return false
        }
      })
    },
    // 删除 科目
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          querySubjectDetail(this.id).then(res => {
            if (res.code == 200) {
              this.form = res.data;
              deleteSubjectById(this.form).then(res => {
                if (res.code == 200) {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  this.form = {};
                  // this.getdata()
                  this.selectAreaTree()
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
                .catch(err => {
                  this.loading = false
                  this.$message.error('删除失败，请稍后再试！')
                })
            }
          })

        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.form = {}
      this.editFormShow = false
    },

    /*
    *  科目配置信息
    * */
    handleFormEdit(index, row) {
      console.log(row)
      this.detailShow = true
      if (row != undefined && row != '') {
        this.detailTitle = '编辑'
        querySubjectDetail(row.id).then(res => {
          if (res.code == 200) {
            this.detailForm = res.data

            if (row.tag == null) {
              queryTagList().then(res => {
                if (res.code == 200) {
                  this.tagList = res.data;
                }
              })
            } else {
              queryTagList().then(res => {
                if (res.code == 200) {
                  this.tagList = res.data;

                  this.tagList.push({
                    id: row.tag,
                    tagName: row.tagName
                  })
                }
              })
            }
          }
        })
      } else {
        this.detailTitle = '添加'
        this.detailForm = {
          subjectId: this.detailSubjectId
        }
      }
    },

    submitDetailForm() {
      this.$refs.detailForm.validate(valid => {
        if (valid) {
          if (this.detailForm.id != undefined) {
            // 修改
            var params = {
              id: this.detailForm.id,
              typeName: this.detailForm.typeName,
              parentId: this.detailForm.parentId,
              tag: this.detailForm.tag,
              tagName: this.detailForm.tagName,
            }
            updateSubject(params).then(res => {
              this.detailShow = false
              this.loading = false
              if (res.code == 200) {
                this.queryTagBySubjectId(this.detailForm.id)
                this.detailForm = {}
                this.$message({
                  type: 'success',
                  message: '科目配置修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.detailShow = false
                this.loading = false
                this.$message.error('科目配置修改失败，请稍后再试！')
              })
          } else {
            // 新增
            savaSubjectDescribe(this.detailForm).then(res => {
              this.detailShow = false
              this.loading = false
              if (res.code == 200) {
                this.querySubjectDescribeBySubjectId(this.detailForm.subjectId)
                this.detailForm = {}
                this.$message({
                  type: 'success',
                  message: '科目配置保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.detailShow = false
                this.loading = false
                this.$message.error('科目配置保存失败，请稍后再试！')
              })
          }
        } else {
          return false
        }
      })
    },

    /*
    *  体验试卷
    * */
    handleTestFormEdit(index, row) {
      console.log(row)
      this.testDetailShow = true
      if (row != undefined && row != '') {
        this.testTitle = '编辑试卷'

        this.detailForm = JSON.parse(JSON.stringify(row));
      } else {
        this.detailTitle = '添加试卷'
        this.detailForm = {
          id: this.detailSubjectId
        }
      }
    },

    submitTestDetailForm() {
      this.$refs.testDetailForm.validate(valid => {
        if (valid) {
          if (this.detailForm.id != undefined) {
            // 修改
            var params = {
              id: this.detailForm.id,
              paperUrl: this.detailForm.paperUrl,
              paperName: this.detailForm.paperName,
            }
            updateSubject(params).then(res => {
              this.testDetailShow = false
              this.loading = false
              if (res.code == 200) {
                this.queryTestPapeBySubjectId(this.detailForm.id)
                this.detailForm = {}
                this.$message({
                  type: 'success',
                  message: '试卷修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.detailShow = false
                this.loading = false
                this.$message.error('科目配置修改失败，请稍后再试！')
              })
          } else {
            // 新增
            savaSubjectDescribe(this.detailForm).then(res => {
              this.testDetailShow = false
              this.loading = false
              if (res.code == 200) {
                this.queryTestPapeBySubjectId(this.detailForm.subjectId)
                this.detailForm = {}
                this.$message({
                  type: 'success',
                  message: '试卷保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.testDetailShow = false
                this.loading = false
                this.$message.error(err.response.data.msg)
              })
          }
        } else {
          return false
        }
      })
    },

    deleteKmPz(index, row) {
      this.$confirm('确定要删除该条标签信息吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteSubjectDescribe(row).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.detailForm = {};
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    detailClose() {
      this.detailShow = false;
      this.detailForm = {};

      this.testDetailShow = false;
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

  /* 左侧树 搜索部分 */
  .tree-con {
    width: 250px;
    height: 95%;
    vertical-align: text-top;
    margin-top: 20px;
    display: inline-block;
    border: #014160 2px solid;
    border-radius: 8px;
  }
  .tree-con .custom-tree-node {
    width: 100%;
  }
  .tree-con .custom-tree-node .custom-tree-node-name {
    width: 80%;
    display: inline-block;
  }

  .head-search {
    border-radius: 8px 0 0 0 !important;
    margin-top: 0px;
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  /deep/ .tree-con input {
    border-radius: 8px 0 0 0 !important;
  }
  .head-tree {
    height: calc(100% - 55px);
    overflow-x: hidden;
  }

  /* 选中 高亮 */
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(83, 131, 237) !important;
  color: #dadada;
}

  /* 右侧表格 */
  .con-rig {
    width: calc(100% - 270px);
    height: 95%;
    display: inline-block;
    flex-direction: column;
    margin-left: 10px;
    vertical-align: text-top;
  }

  /* 右键 树菜单 */
  .menu-item {
    display: block;
    line-height: 20px;
    text-align: center;
    margin-top: 2px;
  }
  .menu-item:hover{
    background-color: #66b1ff;
    color: white;
    cursor:pointer;
  }
  .menu {
    /*height: 35px;*/
    width: 90px;
    position: absolute;
    border: 1px solid #999;
    border-radius: 10px;
    background-color: #f4f4f4;
    padding: 5px 0px;
  }

  li:hover {
    background-color: #1790ff;
    color: white;
  }

</style>





// WEBPACK FOOTER //
// src/views/goods/subjectTree.vue